import { Tab } from '@shared/types/mylounge/ccfEntries';

export interface State {
    tabs: Tab[];
}

export const initialState: State = {
    tabs: [],
};
